import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ComponentRef, computed, effect, inject, Injectable, signal } from '@angular/core';
import { BottomContextMenuComponent } from './bottom-context-menu.component';
import { ContextMenuItem } from '@atsystems/ui';
import { SelectionService } from '../../services/selection.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { fromEvent, map, startWith } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BottomContextMenuService {

  private overlay = inject(Overlay);
  private overlayRef: OverlayRef | null = null;
  private componentRef: ComponentRef<BottomContextMenuComponent> | null = null;
  public selectionService = inject(SelectionService);

  public menuItems = signal<ContextMenuItem[]>([]);

  private readonly resize$ = fromEvent(window, 'resize').pipe(
    map(() => window.innerWidth),
    startWith(window.innerWidth)
  );

  public windowWidth = toSignal(this.resize$, { initialValue: window.innerWidth });

  public selectedCount = computed(() => this.selectionService.getSelectedItems().length);
  public selectedItems = computed(() => this.selectionService.getSelectedItems());

  constructor() {

    effect(() => {
      if (this.selectionService.getSelectedItems().length > 0) {
        this.show();
      } else {
        this.hide();
      }
    });
  }

  public show() {
    const items = this.menuItems();

    if (!this.overlayRef) {
      this.overlayRef = this.overlay.create({
        hasBackdrop: false,
        panelClass: 'bottom-menu-overlay',
        positionStrategy: this.overlay.position()
          .global()
          .bottom(this.windowWidth() > 765 ? '20px' : '0px')
          .centerHorizontally(),
        scrollStrategy: this.overlay.scrollStrategies.reposition()
      });

      const portal = new ComponentPortal(BottomContextMenuComponent);
      this.componentRef = this.overlayRef.attach(portal);
    }

    if (this.componentRef) {
      items.push({
        label: 'Copy',
        icon: 'i i-copy',
        command: () => this.copyStrings()
      });
      this.componentRef.instance.selectedCount.set(this.selectedCount());
      this.componentRef.instance.items.set(items);
    }
  }

  public hide() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  public copyStrings(): void {
    if (this.selectedItems().length) {
      let dataToCopy = '';
      let header = Object.keys(this.selectedItems()[0]).join('\t');
      dataToCopy += header + '\n';
      this.selectedItems().forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          dataToCopy += element[key] + '\t';
        });
        dataToCopy += '\n'
      });
      this.copy(dataToCopy);
    }
  }

  public copy(value: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

}
